<template>
  <div class="root">
    <TheHeader></TheHeader>
    <main class="App__main" v-if="loading">
      <div class="route-wrapper">
        <div class="spotlight-card text-grey" style="justify-content: flex-start;">
          <h2>Loading...</h2>
          <svg viewBox="0 0 1024 1024" fill="currentColor" width="3em" height="3em" class="spin">
            <path
              d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
            />
          </svg>
        </div>
      </div>
    </main>
    <main class="App__main" v-if="!loading">
      <Login v-if="page === 'login' || page === 'email-verification' && customer === 'superfluous'" />
      <ResetPassword v-else-if="page === 'request-password-reset'" />
      <NewPassword v-else-if="page === 'reset-password'" />
      <AcceptInvite v-else-if="isInvitePage" v-bind:state="acceptInviteState" v-bind:customer="customerData"/>
      <EmailVerification v-else-if="page === 'email-verification'" v-bind:state="customer"/>
      <InvalidPassword v-else-if="page === 'invalid-password-reset-token'" />
      <div class="route-wrapper" v-else>
        <div class="spotlight-card text-grey" style="justify-content: flex-start;">
          <h2>Ooops!</h2>
          <div>
            <div class="form-item" style="text-align:left;">
              <h3>Something went wrong!</h3>
              <p class="info text-grey no-account">
                Please click
                <a
                  :href="'/portal/request-password-reset?lang=' + getLang()"
                  class="primary-color"
                >here</a> to login.
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
// eslint-disable-next-line
import TheHeader from "./components/TheHeader.vue";
import AcceptInvite from './views/AcceptInvite.vue';
import EmailVerification from './views/EmailVerification.vue';
import InvalidPassword from "./views/InvalidPassword.vue";
import Login from "./views/Login.vue";
import NewPassword from "./views/NewPassword.vue";
import ResetPassword from "./views/ResetPassword.vue";

import ConnectApi from "./api/connect.api";
import { getQueryParam, getRedirectQueryParam } from "./shared/utilities";

export default {
  name: "App",
  components: {
    AcceptInvite,
    EmailVerification,
    TheHeader,
    Login,
    ResetPassword,
    NewPassword,
    InvalidPassword
  },
  data() {
    const [ page, customer ] = location.pathname.slice(1).replace('portal/', '').split('/');

    return {
      year: new Date().getFullYear(),
      loading: true, // show loading until authentication check is finished
      page,
      customer,
      customerData: undefined
    };
  },
  watch: {
    "$i18n.locale": function() {
      this.setZenDeskConfigurations()
    }
  },
  computed: {
    isInvitePage: function() {
      return [
        'invalid-invitation-token',
        'accept-invitation',
        'accept-customer-access',
      ].includes(this.page);
    },
    pageNeedsAuthCheck: function() {
      return ![
        'reset-password',
        'email-verification',
        'request-password-reset',
        'invalid-password-reset-token',
      ].includes(this.page) && !this.isInvitePage;
    },
    pageNeedsCustomerData: function() {
      return this.page === 'accept-customer-access'
    },
    acceptInviteState: function() {
      return this.page === 'invalid-invitation-token'
        ? 'invalid'
        : this.page === 'accept-customer-access'
          ? (this.customerData && this.customer ? 'success-access' : 'invalid')
          : 'initial';
    }
  },
  methods: {
    getLang() {
      return encodeURIComponent(getQueryParam("lang"));
    },
    setZenDeskConfigurations() {
       if(!window.zE){
         return null;
       }
      const response = this.$i18n.messages[this.$i18n.locale]["zendesk"];
      window.zE("webWidget", "updateSettings", {
        webWidget: {
          color: {
            theme: window.__config__.css.primaryBg,
            launcherText: "#fff",
            button: window.__config__.css.secondaryBg,
            header: window.__config__.css.secondaryBg,
            articleLinks: window.__config__.css.primaryBg
          },
          launcher: {
            label: {
              "*": response.launcher
            }
          },
          helpCenter: {
            searchPlaceholder: {
              "*": response.search
            },
            messageButton: {
              "*": response.contact
            },
            suppress: false
          },
          contactForm: {
            enabled: true,
            subject: true,
            attachments: false
          }
        }
      });
    }
  },
  async mounted() {
    this.setZenDeskConfigurations();

    if (this.pageNeedsCustomerData && this.customer) {
      this.customerData = await ConnectApi.getCustomerData(this.customer);
    }

    if (this.pageNeedsAuthCheck) {
      try {
        await ConnectApi.isAuthenticated();

        location.replace(getRedirectQueryParam() || window.__config__.loginUrl);
      } catch {
        // empty
      }
    }

    this.loading = false;
  }
};
</script>

<style lang="scss">
@import "./styles/_global.scss";

.root {
  padding-top: 64px;
  height: 100vh;
}
main {
  min-height: calc(100vh - 64px);
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #f7f9fd;
  font-size: 14px;
}
.spin {
  animation: 1s linear infinite loadingCircle;
  display: inline;
  top: 0;
  bottom: 0;
  right: 8px;
  margin: auto;
}
</style>


